// extracted by mini-css-extract-plugin
export default {"fullWidth":"wn-z","image":"xn-z","lazyLoadPicture":"yn-z","lazyLoadSpinner":"zn-z","lazyLoadSpin":"An-z","lazyLoadImage":"Bn-z","hasStyledAspectRatio":"Cn-z"};